/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { usePageData } from '../../../core'
import { CreateAppModal } from '../../../../partials'
import { KTSVG } from '../../../../helpers'
import { Button, Typography } from '@mui/material'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'

const ToolbarClassic = () => {
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const { pageButtons } = usePageData()
  const navigate = useNavigate()

  return (
    <div className='d-flex align-items-center gap-2 gap-lg-3' id='toolbar_buttons'>
      {pageButtons &&
        pageButtons.map((button, key) =>
          button.tooltip ? (
            <OverlayTrigger
              key={key}
              placement='top'
              delay={{ show: 50, hide: 100 }}
              overlay={<Tooltip>{button.tooltip}</Tooltip>}
            >
              <span
                role={button.disabled && button.blockedLink ? 'button' : undefined}
                tabIndex={button.disabled && button.blockedLink ? 0 : -1}
                onClick={() => {
                  if (button.disabled && button.blockedLink) {
                    navigate(button.blockedLink)
                  }
                }}
                onKeyDown={(event) => {
                  if (!button.disabled || !button.blockedLink) return
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    navigate(button.blockedLink)
                  }
                }}
              >
                <Button
                  type='button'
                  href={button.link}
                  className={button.class}
                  disabled={button.disabled}
                  onClick={button.onClick}
                >
                  {button.icon && (
                    <KTSVG path={button.icon} className='svg-icon svg-icon-2 svg-icon-gray-800' />
                  )}
                  <div style={{ whiteSpace: 'nowrap' }}>{button.text}</div>
                  {button.icon2 && <i className={button.icon2}></i>}
                </Button>
              </span>
            </OverlayTrigger>
          ) : button.type === 'checkbox' ? (
            <div key={key} className='d-flex align-items-center gap-2'>
              <Typography variant='body1' fontWeight={"bold"} className='mb-0'>{button.text}</Typography>
              <label className='dash-toolbar-toggle form-check form-switch form-check-custom form-check-solid mb-0'>
                <input
                  className={`form-check-input h-20px w-30px `}
                  type='checkbox'
                  role='button'
                  onChange={button.onClick}
                />
              </label>
            </div>
          ) : button.customRender ? (
          <div key={key}>
            {button.customRender()}
          </div>
        ) : (
            <Button
              key={key}
              type='button'
              href={button.link}
              className={button.class}
              disabled={button.disabled}
              onClick={button.onClick}
            >
              {button.icon && (
                <KTSVG path={button.icon} className='svg-icon svg-icon-2 svg-icon-gray-800' />
              )}
              <div style={{ whiteSpace: 'nowrap' }}>{button.text}</div>
              {button.icon2 && <i className={button.icon2}></i>}
            </Button>
          )
        )}
      {/* 
        //@ts-ignore */}
      <CreateAppModal show={showCreateAppModal} handleClose={() => setShowCreateAppModal(false)} />
    </div>
  )
}

export { ToolbarClassic }
